import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IBranchPromiseLookupService } from "../IBranchPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BranchReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.BranchImpl>
  implements IBranchPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.BranchImpl, "BranchImpl");
  }

  getBranch(id: string): Promise<CubiqTS.BranchImpl> {
    let request = new UiArguments("getBranch");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAllBranchCodes(): Promise<Array<string>> {
    let request = new UiArguments("getAllBranchCodes");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getCompleteListOfBranchCodes(): Promise<Array<string>> {
    let request = new UiArguments("getCompleteListOfBranchCodes");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
